/* Iris Academia — consultation booking calendar.
   Each bookable day is a variant (option "Date" = YYYY-MM-DD) of the "Atelier Consultation"
   product with stock 1, so a day disappears once booked. Booking adds it to the cart and goes to checkout;
   Shopify then sends the owner the order email + mobile notification. */
(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SLOTS = ['10:00', '10:30', '11:00', '11:30', '12:00'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }
  function pretty(s) { var p = s.split('-'), dt = new Date(+p[0], +p[1] - 1, +p[2]); return DAYS[dt.getDay()] + ' ' + (+p[2]) + ' ' + MONTHS[+p[1] - 1] + ' ' + p[0]; }

  function init() {
    var box = document.querySelector('[data-ia-consult-book]');
    if (!box || box.dataset.iaInited) return;
    box.dataset.iaInited = '1';
    var data = { variants: [] };
    try { data = JSON.parse(box.querySelector('[data-ia-consult-data]').textContent); } catch (e) {}
    var byDate = {};
    data.variants.forEach(function (v) { if (/^\d{4}-\d{2}-\d{2}$/.test(v.d)) byDate[v.d] = v; });
    var now = new Date(), today = iso(now.getFullYear(), now.getMonth(), now.getDate());
    var dates = Object.keys(byDate).filter(function (d) { return d > today; }).sort();
    var firstOpen = dates.filter(function (d) { return byDate[d].a; })[0] || dates[0];
    var cur = firstOpen ? { y: +firstOpen.slice(0, 4), m: +firstOpen.slice(5, 7) - 1 } : { y: now.getFullYear(), m: now.getMonth() };
    var minM = dates.length ? { y: +dates[0].slice(0, 4), m: +dates[0].slice(5, 7) - 1 } : cur;
    var maxM = dates.length ? { y: +dates[dates.length - 1].slice(0, 4), m: +dates[dates.length - 1].slice(5, 7) - 1 } : cur;
    var state = { date: null, time: null };

    var grid = box.querySelector('[data-cal-grid]'), title = box.querySelector('[data-cal-title]');
    var prev = box.querySelector('[data-cal-prev]'), next = box.querySelector('[data-cal-next]');
    var chosen = box.querySelector('[data-cal-chosen]'), times = box.querySelector('[data-cal-times]'), slots = box.querySelector('[data-cal-slots]');
    var form = box.querySelector('[data-ia-consult-form]'), err = box.querySelector('[data-cal-error]'), submit = box.querySelector('[data-cal-submit]');
    function cmp(a, b) { return a.y * 12 + a.m - (b.y * 12 + b.m); }

    function drawCal() {
      title.textContent = MONTHS[cur.m] + ' ' + cur.y;
      prev.disabled = cmp(cur, minM) <= 0; next.disabled = cmp(cur, maxM) >= 0;
      prev.style.opacity = prev.disabled ? '0.35' : '1'; next.style.opacity = next.disabled ? '0.35' : '1';
      var first = new Date(cur.y, cur.m, 1), lead = (first.getDay() + 6) % 7, n = new Date(cur.y, cur.m + 1, 0).getDate();
      var h = '';
      for (var i = 0; i < lead; i++) h += '<span></span>';
      for (var d = 1; d <= n; d++) {
        var key = iso(cur.y, cur.m, d), v = byDate[key], future = key > today;
        var base = 'aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;font-family:inherit;font-size:15px;border:1px solid transparent;';
        if (v && future && v.a) {
          var on = state.date === key;
          h += '<button type="button" data-day="' + key + '" aria-label="' + pretty(key) + ', available" aria-pressed="' + on + '" style="' + base + 'cursor:pointer;' + (on ? 'background:#3B2418;color:#F4F0E8;border-color:#3B2418;' : 'background:#EFE6DA;color:#3B2418;border-color:#9E7A4A;') + '">' + d + '</button>';
        } else if (v && future) {
          h += '<span title="Booked" aria-label="' + pretty(key) + ', booked" style="' + base + 'color:#9a8b76;text-decoration:line-through;background:repeating-linear-gradient(135deg,#E5DCCB 0 3px,#D2C5AE 3px 6px);">' + d + '</span>';
        } else {
          h += '<span style="' + base + 'color:#bfb29c;">' + d + '</span>';
        }
      }
      grid.innerHTML = h;
      grid.querySelectorAll('[data-day]').forEach(function (b) { b.addEventListener('click', function () { state.date = b.dataset.day; err.hidden = true; drawCal(); drawSide(); }); });
    }
    function drawSide() {
      chosen.textContent = state.date ? pretty(state.date) : 'Choose an available day';
      times.hidden = !state.date;
      slots.innerHTML = SLOTS.map(function (t) {
        var on = state.time === t;
        return '<button type="button" data-slot="' + t + '" style="padding:10px 16px;cursor:pointer;font-family:inherit;font-size:15px;' + (on ? 'background:#3B2418;color:#F4F0E8;border:1px solid #3B2418;' : 'background:#FBF7EF;color:#3B2418;border:1px solid #C9BCA4;') + '">' + t + '</button>';
      }).join('');
      slots.querySelectorAll('[data-slot]').forEach(function (b) { b.addEventListener('click', function () { state.time = b.dataset.slot; err.hidden = true; drawSide(); }); });
      var price = window.IrisCart ? window.IrisCart.money(data.price) : '€' + (data.price / 100);
      submit.textContent = 'Book & continue to payment · ' + price;
    }
    function showErr(m) { err.textContent = m; err.hidden = false; }
    prev.addEventListener('click', function () { if (prev.disabled) return; cur.m--; if (cur.m < 0) { cur.m = 11; cur.y--; } drawCal(); });
    next.addEventListener('click', function () { if (next.disabled) return; cur.m++; if (cur.m > 11) { cur.m = 0; cur.y++; } drawCal(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      if (!dates.length) return showErr('Online booking is not open yet. Please write to us and we will arrange a time.');
      if (!state.date) return showErr('Please choose an available day in the calendar.');
      if (!state.time) return showErr('Please choose a start time.');
      if (!form.elements['name'].value.trim()) { form.elements['name'].focus(); return showErr('Please add your name.'); }
      var v = byDate[state.date];
      var props = { 'Consultation date': pretty(state.date), 'Start time': state.time + ' (Athens time)', 'Name': form.elements['name'].value.trim() };
      if (form.elements['phone'].value.trim()) props['Phone'] = form.elements['phone'].value.trim();
      if (form.elements['story'].value.trim()) props['Your story'] = form.elements['story'].value.trim();
      if (!window.IrisCart) return showErr('Booking is not available right now. Please refresh the page and try again.');
      submit.disabled = true; submit.textContent = 'Reserving your day…';
      window.IrisCart.add([{ id: v.id, quantity: 1, properties: props }]).then(function () {
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'checkout';
      }).catch(function (x) {
        submit.disabled = false; drawSide();
        showErr((x && x.message) || 'That day has just been booked. Please choose another day.');
      });
    });
    drawCal(); drawSide();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
